import React, { useEffect, useState } from 'react';
import systemService from '../services/systemService';

/**
 * Globales Sicherheitsbanner: ist der Dry-Run-Modus (OUTREACH_DRY_RUN) aktiv,
 * werden Lemlist-Pushes nur simuliert; LinkedIn-Publishing hat einen eigenen
 * Schalter (LINKEDIN_DRY_RUN, ungesetzt wie OUTREACH_DRY_RUN). Das Banner macht
 * den Zustand überall sichtbar, damit beim Testen niemand versehentlich echte
 * Sends erwartet. Instagram, X und Facebook haben je einen eigenen Schalter
 * (INSTAGRAM_DRY_RUN, X_DRY_RUN, FACEBOOK_DRY_RUN; ungesetzt wie OUTREACH_DRY_RUN).
 */
const DryRunBanner: React.FC = () => {
  const [dryRun, setDryRun] = useState(false);
  const [linkedInDryRun, setLinkedInDryRun] = useState(false);
  const [socialDryRun, setSocialDryRun] = useState<string[]>([]);

  useEffect(() => {
    let active = true;
    systemService
      .getHealth()
      .then((h) => {
        if (!active) return;
        setDryRun(!!h.dryRun);
        // Aeltere Backends kennen linkedInDryRun nicht: dann gilt dryRun.
        setLinkedInDryRun(h.linkedInDryRun ?? !!h.dryRun);
        // Aeltere Backends kennen die Social-Schalter nicht: dann kein Eintrag.
        setSocialDryRun([
          h.instagramDryRun ? 'Instagram' : '',
          h.xDryRun ? 'X' : '',
          h.facebookDryRun ? 'Facebook' : '',
        ].filter(Boolean));
      })
      .catch(() => {
        // Health nicht erreichbar → kein Banner (fail-quiet).
      });
    return () => {
      active = false;
    };
  }, []);

  const kanaele = [dryRun ? 'Lemlist' : '', linkedInDryRun ? 'LinkedIn' : '', ...socialDryRun].filter(Boolean);
  if (kanaele.length === 0) return null;
  const was = kanaele.join(' / ');

  return (
    <div
      role="status"
      style={{
        background: 'var(--color-warning, #b45309)',
        color: '#fff',
        padding: 'var(--space-2, 8px) var(--space-4, 16px)',
        fontSize: 'var(--text-sm, 0.875rem)',
        fontWeight: 600,
        textAlign: 'center',
        letterSpacing: '0.01em',
      }}
    >
      🟡 Dry-Run aktiv — ausgehende Outreach-Aktionen ({was}) werden simuliert, es
      wird niemand real angeschrieben.
    </div>
  );
};

export default DryRunBanner;
